//BASE
let _DOMAIN = '';
let _STUDIES_DOMAIN = '';

if (window.location.hostname === 'monitoring.uhda.health') {
  _DOMAIN = 'https://backend.monitoring.uhda.health'; // Domain for production
  _STUDIES_DOMAIN = 'https://backend.studies.uhda.health';
} else {
  _DOMAIN = 'https://test.backend.monitoring.uhda.health'; // Default domain if none of the conditions match
  _STUDIES_DOMAIN = 'https://test.backend.studies.uhda.health';
}

const _API_PATH = '/api';
export const BASE_PATH = `${_DOMAIN}${_API_PATH}`;
const _FRONTEND_PATH = '/frontend';

// STUDIES PATHS
export const STUDIES_BASE_PATH = `${_STUDIES_DOMAIN}${_API_PATH}`;
const _STUDIES_LOGIN_PATH = '/auth/login';
export const STUDIES = '/studies';
export const STUDY = '/study';

export const GET_STUDY = (studyId) => `${STUDY}/${studyId}`;

export const GET_FORMS_SUMMARY = (studyId) =>
  `${STUDY}/${studyId}/summary-forms/locale/en`;

export const GET_ANSWERS = (formId) => `/form/${formId}/answers`;

export const GET_ANSWERS_PAGINATED = (formId, page, size) =>
  `/form/${formId}/answers?page=${page}&perpage=${size}`;

export const DELETE_ANSWER = `/form-answers`;

export const GET_STUDIES_QUESTIONS = (studyId, formId) =>
  `${STUDIES}/${studyId}/form/${formId}/questions`;

// AUTH PATHS
const _LOGIN_PATH = '/authenticate';

// PATIENTS PATHS
const _PATIENTS_PATH = '/patients';
const _PATIENTS_BY_CENTER_PATH = '/patientsByCenter';
const _OBSERVATIONS_PATH = '/observations';
const _FIRST_OBSERVATIONS_PATH = '/firstObservation';
const _EXPORT_OBSERVATIONS_PATH = '/exportObservations';
const _IMPORT_PATIENTS_PATH = '/register-patients';

// CENTERS PATHS
const _CENTERS_PATH = '/centers';

// NOTES PATHS
const _NOTES_PATH = '/notes';

// MESSAGES PATHS
const _MESSAGES_PATH = '/messages';
const _MESSAGES_BY_USER_PATH = '/messages-by-user';

// CONTENT BY CENTER PATHS
const _CONTENT_PATH = '/contents';
const _CONTENT_BY_CENTER_PATH = '/contents-by-center';
const _ASSOCIATE_CONTENT_AND_PATIENT_PATH = '/associate-content-to-patient';

// PATIENT CONTENT PATHS
const _GET_PATIENTS_CONTENT = '/contents-by-patient';
const _PATCH_PATIENTS_CONTENT = '/patient-contents';
const _DELETE_PATIENTS_CONTENT = '/delete-patient-content';

// PROFESSIONALS PATHS
const _PROFESSIONALS_PATH = '/professionals';
const _PROFESSIONALS_BY_CENTER_PATH = '/professionalsByCenter';

// FORMS PATHS
const _FORMS_PATH = '/formList';
const _FORMS_BY_PATIENT = '/forms-by-patient';

// SCHEDULED FORMS PATHS
const _SCHEDULED_FORMS_BY_CENTER_PATH = '/scheduledforms-by-center';
const _SCHEDULED_FORMS_PATH = '/form-schedulings';

// ALERTS PATHS
const _ALERTS_PATH = '/alerts';
const _ALERTS_BY_CENTER_EXTENSION = '-by-center';

// REPORTS PATHS
const _REPORTS_PATH = '/reports';
const _REPORTS_PATH_BY_PATIENT = '-by-patient';

// SCORE PATHS
const _SCORE_PATH = '/scores';
const _SCORE_PATH_BY_PATIENT = '-by-patient';

// PACKAGE PATHS
const _PACKAGE_PATH = "/intervention";
const _PACKAGE_PATCH_PATH = "/interventions";

// ORGANIZATION PATH
const _ORGANIZATION_PATH = "/organizations";

// STUDIES ENDPOINTS
export const LOGIN_STUDIES = `${STUDIES_BASE_PATH}${_STUDIES_LOGIN_PATH}`;

// ALERTS ENDPOINTS
export const GET_ALERTS = (centerId, page, size) =>
  `${_FRONTEND_PATH}${_ALERTS_PATH}${_ALERTS_BY_CENTER_EXTENSION}?centerId=${centerId}&page=${page}&size=${size}`;
export const GET_NOT_READ_ALERTS = (centerId) =>
  `${_FRONTEND_PATH}/pending-alerts-by-center/${centerId}`;
export const PATCH_OR_DELETE_ALERT = (alertId) =>
  `${_FRONTEND_PATH}${_ALERTS_PATH}/${alertId}`;

// REPORTS ENDPOINT
export const REPORTS_BY_PATIENT = (patientId) =>
  `${_FRONTEND_PATH}${_REPORTS_PATH}${_REPORTS_PATH_BY_PATIENT}/${patientId}`;

// SCORES ENDPOINT
export const SCORE_BY_PATIENT = (patientId) =>
  `${_FRONTEND_PATH}${_SCORE_PATH}${_SCORE_PATH_BY_PATIENT}/${patientId}`;

// PACKAGES ENDPOINT
export const POST_PACKAGE = (centerId) =>
  `${_FRONTEND_PATH}${_PACKAGE_PATH}/${centerId}`;

export const PATCH_PACKAGE = (packageId) =>
  `${_FRONTEND_PATH}${_PACKAGE_PATCH_PATH}/${packageId}`;

// WIZARDS ENDPOINT
export const GET_WIZARDS = `${_FRONTEND_PATH}/wizards`;

// ORGANIZATION ENDPOINT
export const GET_ORGANIZATIONS = () => `${_FRONTEND_PATH}${_ORGANIZATION_PATH}`;

export const POST_ORGANIZATION = () => `${_FRONTEND_PATH}${_ORGANIZATION_PATH}`;

export const PATCH_ORGANIZATION = (organizationId) => 
  `${_FRONTEND_PATH}${_ORGANIZATION_PATH}/${organizationId}`;

export const DELETE_ORGANIZATION = (organizationId) => 
  `${_FRONTEND_PATH}${_ORGANIZATION_PATH}/${organizationId}`;

// ENDPOINTS
export const GET_CENTERS = `${_FRONTEND_PATH}${_CENTERS_PATH}`;

export const POST_CENTER = `${_FRONTEND_PATH}${_CENTERS_PATH}`;

export const GET_APPS = `${_FRONTEND_PATH}/apps`;

export const GET_PACKAGES = `${_FRONTEND_PATH}/business-packages`;

export const DELETE_OR_UPDATE_CENTER = (centerId) =>
  `${_FRONTEND_PATH}${_CENTERS_PATH}/${centerId}`;

export const GET_FORMS = (centerId) =>
  `${_FRONTEND_PATH}${_FORMS_PATH}/${centerId}`;

export const POST_FORM = (centerId) =>
  `${_FRONTEND_PATH}${_FORMS_PATH}/${centerId}`;

export const FORMS_BY_PATIENT = (patientId) =>
  `${_FRONTEND_PATH}${_FORMS_BY_PATIENT}/${patientId}`;

export const PROFESSIONALS_URL = `${_FRONTEND_PATH}${_PROFESSIONALS_PATH}`;

export const PROFESSIONALS_BY_CENTER_URL = (centerId) =>
  `${_FRONTEND_PATH}${_PROFESSIONALS_BY_CENTER_PATH}/${centerId}`;

export const DELETE_OR_UPDATE_PROFESSIONAL = (professionalId) =>
  `${_FRONTEND_PATH}${_PROFESSIONALS_PATH}/${professionalId}`;

export const DELETE_OR_UPDATE_PATIENT = (patientId) =>
  `${_FRONTEND_PATH}${_PATIENTS_PATH}/${patientId}`;

export const LOGIN_URL = `${_FRONTEND_PATH}${_LOGIN_PATH}`;

export const PATIENTS_URL = `${_FRONTEND_PATH}${_PATIENTS_PATH}`;

export const IMPORT_PATIENTS_URL = `${_FRONTEND_PATH}${_IMPORT_PATIENTS_PATH}`;

export const PATIENTS_BY_CENTER_URL = (centerId) =>
  `${_FRONTEND_PATH}${_PATIENTS_BY_CENTER_PATH}/${centerId}`;

export const GET_PATIENT_NOTES = (patientId) =>
  `${_FRONTEND_PATH}${_NOTES_PATH}?patientId=${patientId}`;

export const POST_PATIENT_NOTE = `${_FRONTEND_PATH}${_NOTES_PATH}`;

export const DELETE_OR_PATCH_NOTE = (noteId) => `${_NOTES_PATH}/${noteId}`;

export const GET_USER_MESSAGES = (patientId) =>
  `${_FRONTEND_PATH}${_MESSAGES_BY_USER_PATH}/${patientId}`;

export const POST_USER_MESSAGE = `${_FRONTEND_PATH}${_MESSAGES_PATH}`;

export const DELETE_OR_PATCH_MESSAGE = (messageId) =>
  `${_MESSAGES_PATH}/${messageId}`;

export const GET_CENTER_CONTENT = (centerId) =>
  `${_FRONTEND_PATH}${_CONTENT_BY_CENTER_PATH}/${centerId}`;

export const POST_CENTER_CONTENT = `${_FRONTEND_PATH}${_CONTENT_PATH}`;

export const ASSOCIATE_CONTENT_AND_PATIENT = `${_FRONTEND_PATH}${_ASSOCIATE_CONTENT_AND_PATIENT_PATH}`;

export const DELETE_OR_PATCH_CONTENT = (contentId) =>
  `${_FRONTEND_PATH}${_CONTENT_PATH}/${contentId}`;

export const GET_PATIENT_CONTENT = (patientId) =>
  `${_FRONTEND_PATH}${_GET_PATIENTS_CONTENT}/${patientId}`;

export const UPDATE_PATIENT_CONTENT = (contentId) =>
  `${_PATCH_PATIENTS_CONTENT}/${contentId}`;

export const DELETE_PATIENT_CONTENT = (contentId) =>
  `${_FRONTEND_PATH}${_DELETE_PATIENTS_CONTENT}/${contentId}`;

export const OBSERVATIONS_URL = (
  type,
  patientId,
  startDate,
  endDate,
  aggregation
) =>
  `${_FRONTEND_PATH}${_OBSERVATIONS_PATH}?type=${type}&patientId=${patientId}${
    startDate ? '&startDate=' + startDate : ''
  }${endDate ? '&endDate=' + endDate : ''}${
    aggregation ? '&aggregation=' + aggregation : ''
  }`;

export const FIRST_OBSERVATION_URL = (type, patientId) =>
  `${_FRONTEND_PATH}${_FIRST_OBSERVATIONS_PATH}?type=${type}&patientId=${patientId}`;

export const EXPORT_OBSERVATIONS_URL = (
  type,
  patientId,
  startDate,
  endDate,
  aggregation
) =>
  `${_FRONTEND_PATH}${_EXPORT_OBSERVATIONS_PATH}?${
    type ? '&type=' + type : ''
  }&patientId=${patientId}${startDate ? '&startDate=' + startDate : ''}${
    endDate ? '&endDate=' + endDate : ''
  }${aggregation ? '&aggregation=' + aggregation : ''}`;

export const GET_SCHEDULED_FORMS = (centerId) =>
  `${_FRONTEND_PATH}${_SCHEDULED_FORMS_BY_CENTER_PATH}/${centerId}`;

export const POST_SCHEDULED_FORM = `${_FRONTEND_PATH}${_SCHEDULED_FORMS_PATH}`;

export const PATCH_SCHEDULED_FORM = (formId) =>
  `${_FRONTEND_PATH}${_SCHEDULED_FORMS_PATH}/${formId}`;

export const DELETE_SCHEDULED_FORM = (formId) =>
  `${_FRONTEND_PATH}${_SCHEDULED_FORMS_PATH}/${formId}`;
